import { PROMOTION_API_BASE } from './promotionApi';

/**
 * Salvează quiz completat (nume + email) pe server — fișier local în production.
 * Fire-and-forget: nu blochează UX-ul quiz-ului.
 */
export function submitQuizCompletion({ name, email, speakerId, outcome }) {
  const payload = {
    name: name.trim(),
    email: email.trim(),
    speaker_id: speakerId || '',
    outcome: outcome || '',
  };

  return fetch(`${PROMOTION_API_BASE}/api/quiz/submissions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(payload),
  }).catch((err) => {
    console.warn('Quiz submission save failed:', err);
    return null;
  });
}
